interface Teacher {
  name: string;
  role: string;
  description: string;
  experience: string;
  education: string[];
  specialization: string[];
  languages: { language: string; level: string }[];
  contact?: {
    email?: string;
    institutionalEmail?: string;
    phone?: string;
  };
  iconType: 'literature' | 'math' | 'languages';
}

export const teachersData: Teacher[] = [
  {
    name: "Cosmin",
    role: "Profesor de Limba și Literatura Română",
    description: "Pasiunea pentru limba și literatura română, dar și anii de lucru petrecuți împreună cu elevii m-au determinat să urmez această profesie. Totul trebuie făcut din plăcere, devotament și abilitatea de a avea răbdare.",
    experience: "Specializat în pregătirea elevilor din învățământul preuniversitar",
    education: [
      "Liceul Tehnologic nr. 1 Balș OLT (2018-2022)",
      "Academia de Studii Economice BUCUREȘTI - Facultatea de Contabilitate și Informatică de Gestiune (2022-prezent)",
      "Academia de Studii Economice BUCUREȘTI - Departamentul pentru pregătirea personalului didactic (2022-prezent)"
    ],
    specialization: [
      "Cadru didactic în învățământul preuniversitar",
      "Specialist în domeniul economic"
    ],
    languages: [
      { language: "Română", level: "Nativ" }
    ],
    iconType: "literature"
  },
  {
    name: "Mihaela",
    role: "Profesor de Limbi Străine",
    description: "Specializată în traduceri și comunicare interculturală, cu o abordare adaptată nevoilor fiecărui student.",
    experience: "Expert în comunicare interculturală și traduceri specializate",
    education: [
      "Licență în Resurse Umane - Facultatea de Administrație și Afaceri, Universitatea din București",
      "Master în Terminologie și Traductologie - Studii Hispanice, Facultatea de Limbi și Literaturi Străine, Universitatea din București"
    ],
    specialization: [
      "Traduceri specializate (spaniolă-română)",
      "Comunicare interculturală",
      "Gestionarea timpului și organizare",
      "Gândire analitică"
    ],
    languages: [
      { language: "Română", level: "Nativ" },
      { language: "Spaniolă", level: "C1" },
      { language: "Engleză", level: "B2-C1" },
      { language: "Suedeză", level: "A1" }
    ],
    iconType: "languages"
  },
  {
    name: "Alexandra",
    role: "Profesor de Matematică și Programare",
    description: "Specializată în predarea matematicii și programării, cu o abordare practică bazată pe experiența în domeniul ciberneticii economice.",
    experience: "Expertiză în matematică, programare și limba engleză",
    education: [
      "Licență în Cibernetică Economică"
    ],
    specialization: [
      "Matematică",
      "Programare",
      "Limba Engleză"
    ],
    languages: [
      { language: "Română", level: "Nativ" },
      { language: "Engleză", level: "Avansat" },
      { language: "Franceză", level: "Intermediar" }
    ],
    iconType: "math"
  }
]; 